import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { UpdateSocialButtonOrderRequest } from 'stageclip-common';

import {
  editSocialButtons,
  fetchPortalList,
  addNewPortal,
  editPortal,
  getSocialButtons,
  uploadPortalsList,
  deletePortal,
} from 'api/portals/portals.actions';
import { SimpleModalId } from 'constants/modalId';
import { getAll } from 'store/selectors';
import { createModalOpenAction, createModalCloseAction } from 'actions/modalActions';
import { createRequestActiveClientsAction } from 'actions/clientActions';
import { ClippingPlatformState } from 'store/clippingPlatformState';
import { PortalsPage } from './portalsPage';
import { FormFieldsTypes } from './portalsForm/PortalForm.types';
import { OnEditPortalValues } from './PortalsPage.types';
import { PortalsUploadListFormDataProps } from 'components/portals/portalsUploadListForm/PortalsUploadListForm.types';
import { PortalsDeleteFormModalProps } from './portalsDeleteForm/PortalsDeleteForm.types';
import { PortalsClearCacheFormModalProps } from './portalsClearCacheForm/PortalsClearCacheForm.types';

const mapDispatchToProps = (dispatch: Function) => ({
  fetchPortalList: () => dispatch(fetchPortalList()),
  loadClients: (c: PortalsPage) => dispatch(createRequestActiveClientsAction(c, dispatch as Dispatch)),
  onAddPortal: (values: FormFieldsTypes) => dispatch(addNewPortal(values)),
  onEditPortal: (id: string, values: OnEditPortalValues) => dispatch(editPortal(id, values)),
  openEditPortalModal: () => dispatch(createModalOpenAction(SimpleModalId.EditPortalModal)),
  closeAddPortalModal: () => dispatch(createModalCloseAction(SimpleModalId.AddPortalModal)),
  closeEditPortalModal: () => dispatch(createModalCloseAction(SimpleModalId.EditPortalModal)),
  closeSocialMediaModal: () => dispatch(createModalCloseAction(SimpleModalId.SocialMediaModal)),
  fetchSocialButtons: () => dispatch(getSocialButtons()),
  editSocialButtons: (body: UpdateSocialButtonOrderRequest[]) => dispatch(editSocialButtons(body)),
  uploadPortalsList: (body: PortalsUploadListFormDataProps) => dispatch(uploadPortalsList(body)),
  closePortalsUploadModal: () => dispatch(createModalCloseAction(SimpleModalId.PortalsUploadList)),
  openDeletePortalModal: ({ domain, portalId }: PortalsDeleteFormModalProps) =>
    dispatch(createModalOpenAction(SimpleModalId.DeletePortalModal, { domain, portalId })),
  closeDeletePortalModal: () => dispatch(createModalCloseAction(SimpleModalId.DeletePortalModal)),
  deletePortal: (id: string) => dispatch(deletePortal(id)),
  openClearPortalCacheModal: ({ domain }: PortalsClearCacheFormModalProps) =>
    dispatch(createModalOpenAction(SimpleModalId.ClearPortalCacheModal, { domain })),
  closeClearPortalCacheModal: () => dispatch(createModalCloseAction(SimpleModalId.ClearPortalCacheModal)),
});

const mapStateToProps = (state: ClippingPlatformState) => ({
  clients: getAll(state.entities.clients),
});

export const PortalsPageContainer = connect(mapStateToProps, mapDispatchToProps)(PortalsPage);
